import { create, StateCreator } from 'zustand';
import { MissionTab } from '../consts/missionTab';
import { MissionWindowTab } from '../consts/missionWindowTab';
import { devtools } from 'zustand/middleware';

interface UiState {
  isMenuOpen: boolean;
  setIsMenuOpen: (isMenuOpen: boolean) => void;

  isCalendarOpen: boolean;
  setIsCalendarOpen: (isCalendarOpen: boolean) => void;

  selectedMissionsTab: MissionTab | null;
  setSelectedMissionsTab: (selectedSchedulesTab: MissionTab | null) => void;

  selectedMissionWindowTab: MissionWindowTab;
  setSelectedMissionWindowTab: (selectedMissionWindowTab: MissionWindowTab) => void;
}

const createUiStore: StateCreator<UiState, [['zustand/devtools', never]], []> = (set) => ({
  isMenuOpen: false,
  setIsMenuOpen: (isMenuOpen) => set(() => ({ isMenuOpen })),

  isCalendarOpen: false,
  setIsCalendarOpen: (isCalendarOpen) => set(() => ({ isCalendarOpen })),

  selectedMissionsTab: null,
  setSelectedMissionsTab: (selectedMissionsTab) => set(() => ({ selectedMissionsTab })),

  selectedMissionWindowTab: MissionWindowTab.Upload,
  setSelectedMissionWindowTab: (selectedMissionWindowTab) => set(() => ({ selectedMissionWindowTab })),
});

export const useUiStore = create<UiState>()(
  devtools(createUiStore, {
    name: 'UiStore',
    enabled: !isProduction,
  }),
);
